import { NavLink } from "react-router-dom";
import {
    LayoutDashboard,
    Building2,
    Users,
    Wallet,
    Landmark,
    FileSignature,
    Users2,
    Calculator,
    Receipt,
    Coins,
    FolderClosed,
    BellRing,
    Shield,
    ShieldAlert,
    UserCog,
    ChevronRight,
    LineChart,
    Table2,
    Filter,
    FileCheck2,
    AlertTriangle,
    FileBarChart,
    ExternalLink,
    Upload,
    Layers,
    Zap,
    Waves,
    BrainCircuit,
    Radio,
    KeyRound,
    ArrowUpRight,
    Mail,
    ScanLine,
    Scale,
    PhoneCall,
    Gavel,
    ClipboardList,
    FileSearch,
    ListChecks,
} from "lucide-react";
import { useAuth } from "../../lib/auth";
import { useTenant } from "../../lib/tenant";
import { ROLES } from "../../lib/roles";

const SECTIONS = [
    {
        label: "Núcleo",
        items: [
            { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
            { to: "/operacion-diaria", label: "Operación diaria", icon: Radio },
            { to: "/fideicomisos", label: "Fideicomisos", icon: Building2 },
            { to: "/partes-kyc", label: "Partes y KYC", icon: Users },
            { to: "/patrimonio", label: "Patrimonio", icon: Wallet },
            { to: "/tesoreria", label: "Cuentas y Tesorería", icon: Landmark },
            { to: "/instrucciones", label: "Instrucciones", icon: FileSignature },
            { to: "/comite", label: "Comité Técnico", icon: Users2 },
            { to: "/contabilidad", label: "Contabilidad", icon: Calculator },
            { to: "/fiscal", label: "Fiscal", icon: Receipt },
            { to: "/honorarios", label: "Honorarios", icon: Coins },
            { to: "/documental", label: "Documental", icon: FolderClosed },
            { to: "/obligaciones", label: "Obligaciones y Alertas", icon: BellRing },
        ],
    },
    {
        label: "V1 · Garantía",
        items: [
            { to: "/v1/facilities", label: "Facilities", icon: LineChart },
            { to: "/v1/tape", label: "Tape (ingesta)", icon: Upload },
            { to: "/v1/tape/cortes", label: "Cortes de tape", icon: Table2 },
            { to: "/v1/elegibilidad", label: "Elegibilidad", icon: Filter },
            { to: "/v1/borrowing-base", label: "Borrowing Base", icon: FileCheck2 },
            { to: "/v1/covenants", label: "Covenants", icon: AlertTriangle },
            { to: "/v1/waterfall", label: "Waterfall", icon: Waves },
            { to: "/v1/reportes", label: "Reportes lenders", icon: FileBarChart },
            { to: "/v1/portal-externo", label: "Portal Externo", icon: ExternalLink },
        ],
    },
    {
        label: "IA · Verificación documental",
        items: [
            {
                to: "/ia/hil",
                label: "Cola de revisión",
                icon: BrainCircuit,
                roles: [
                    ROLES.ADMINISTRADOR_FIDUCIARIO, ROLES.CUMPLIMIENTO,
                    ROLES.JURIDICO, ROLES.OPERACIONES, ROLES.DIRECCION,
                    ROLES.AUDITOR, ROLES.ADMIN_TI, ROLES.RIESGOS,
                    ROLES.FINANZAS, ROLES.TESORERIA,
                ],
            },
        ],
    },
    {
        label: "A2 · Conexión a la fuente",
        items: [
            {
                to: "/a2/ingestas",
                label: "Ingestas",
                icon: ArrowUpRight,
                roles: [
                    ROLES.ADMINISTRADOR_FIDUCIARIO, ROLES.ADMIN_TI,
                    ROLES.OPERACIONES, ROLES.RIESGOS, ROLES.DIRECCION,
                    ROLES.AUDITOR, ROLES.FINANZAS,
                ],
            },
            {
                to: "/a2/vault",
                label: "Vault de credenciales",
                icon: KeyRound,
                roles: [ROLES.ADMIN_TI],
            },
        ],
    },
    {
        label: "A6 · Data Room + Analytics",
        items: [
            {
                to: "/data-room",
                label: "Data Room seguro",
                icon: ScanLine,
                roles: [
                    ROLES.ADMINISTRADOR_FIDUCIARIO, ROLES.JURIDICO,
                    ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.DIRECCION,
                    ROLES.CUMPLIMIENTO,
                ],
            },
        ],
    },
    {
        label: "Gobierno · Fase 14",
        items: [
            {
                to: "/gobierno",
                label: "Panel de Gobierno",
                icon: Gavel,
                end: true,
                roles: [
                    ROLES.DIRECCION, ROLES.CONSEJO, ROLES.ADMIN_TI,
                    ROLES.AUDITOR, ROLES.CUMPLIMIENTO, ROLES.JURIDICO,
                    ROLES.DELEGADO_FIDUCIARIO,
                ],
            },
            {
                to: "/gobierno/delegados",
                label: "Libro de Delegados",
                icon: UserCog,
                roles: [
                    ROLES.DIRECCION, ROLES.CONSEJO, ROLES.ADMIN_TI,
                    ROLES.AUDITOR, ROLES.CUMPLIMIENTO, ROLES.JURIDICO,
                ],
            },
            {
                to: "/gobierno/matriz-autorizacion",
                label: "Matriz de Autorización",
                icon: Scale,
                roles: [
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR,
                    ROLES.CUMPLIMIENTO, ROLES.CONSEJO,
                    ROLES.OPERACIONES, ROLES.TESORERIA,
                    ROLES.DELEGADO_FIDUCIARIO,
                ],
            },
            {
                to: "/gobierno/call-backs",
                label: "Call-backs",
                icon: PhoneCall,
                roles: [
                    ROLES.DELEGADO_FIDUCIARIO, ROLES.OPERACIONES,
                    ROLES.ADMIN_TI, ROLES.DIRECCION, ROLES.AUDITOR,
                ],
            },
            {
                to: "/gobierno/comite/sesiones",
                label: "Sesiones Comité",
                icon: Users2,
                roles: [
                    ROLES.CONSEJO, ROLES.DIRECCION, ROLES.ADMIN_TI,
                    ROLES.AUDITOR, ROLES.CUMPLIMIENTO, ROLES.JURIDICO,
                    ROLES.RIESGOS,
                ],
            },
            {
                to: "/gobierno/comite/miembros",
                label: "Miembros Comité",
                icon: Shield,
                roles: [
                    ROLES.CONSEJO, ROLES.DIRECCION, ROLES.ADMIN_TI,
                    ROLES.AUDITOR, ROLES.CUMPLIMIENTO, ROLES.JURIDICO,
                    ROLES.RIESGOS,
                ],
            },
            {
                to: "/gobierno/conflictos",
                label: "Conflictos de Interés",
                icon: AlertTriangle,
            },
            {
                to: "/gobierno/reporte-consejo",
                label: "Reporte al Consejo",
                icon: LineChart,
                roles: [ROLES.CONSEJO, ROLES.DIRECCION, ROLES.ADMIN_TI],
            },
        ],
    },
    {
        label: "Aceptación · Fase 15",
        items: [
            {
                to: "/aceptacion/pipeline",
                label: "Pipeline G-02",
                icon: ClipboardList,
                roles: [
                    ROLES.ADMINISTRADOR_FIDUCIARIO, ROLES.OPERACIONES,
                    ROLES.CUMPLIMIENTO, ROLES.JURIDICO, ROLES.RIESGOS,
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR,
                    ROLES.CONSEJO,
                ],
            },
            {
                to: "/aceptacion/dictamenes",
                label: "Dictámenes F-09",
                icon: FileSearch,
                roles: [
                    ROLES.ADMINISTRADOR_FIDUCIARIO, ROLES.OPERACIONES,
                    ROLES.CUMPLIMIENTO, ROLES.JURIDICO, ROLES.RIESGOS,
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR,
                    ROLES.CONSEJO,
                ],
            },
        ],
    },
    {
        label: "Honorarios · Fase 16",
        items: [
            {
                to: "/honorarios/cotizador",
                label: "Cotizador en vivo",
                icon: Calculator,
                roles: [
                    ROLES.OPERACIONES, ROLES.FINANZAS, ROLES.DIRECCION,
                    ROLES.ADMIN_TI, ROLES.CONSEJO,
                ],
            },
            {
                to: "/honorarios/cotizaciones",
                label: "Cotizaciones",
                icon: Receipt,
                roles: [
                    ROLES.OPERACIONES, ROLES.FINANZAS, ROLES.DIRECCION,
                    ROLES.ADMIN_TI, ROLES.CONSEJO, ROLES.AUDITOR,
                ],
            },
            {
                to: "/honorarios/tarifario",
                label: "Tarifario (6 productos)",
                icon: ListChecks,
                roles: [
                    ROLES.FINANZAS, ROLES.DIRECCION, ROLES.ADMIN_TI,
                ],
            },
        ],
    },
    {
        label: "Control Fiduciario · Fase 17",
        items: [
            {
                to: "/control/hub", label: "Hub de vencimientos", icon: AlertTriangle,
                roles: [
                    ROLES.OPERACIONES, ROLES.JURIDICO, ROLES.CUMPLIMIENTO,
                    ROLES.ADMINISTRADOR_FIDUCIARIO, ROLES.DIRECCION,
                    ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.CONSEJO, ROLES.FINANZAS,
                ],
            },
            {
                to: "/control/convenios", label: "Convenios modificatorios · M-11",
                icon: FileSignature,
                roles: [
                    ROLES.JURIDICO, ROLES.OPERACIONES, ROLES.ADMINISTRADOR_FIDUCIARIO,
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.CONSEJO,
                ],
            },
            {
                to: "/control/sustituciones", label: "Sustituciones · M-12",
                icon: Waves,
                roles: [
                    ROLES.JURIDICO, ROLES.ADMINISTRADOR_FIDUCIARIO,
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.CONSEJO,
                ],
            },
            {
                to: "/control/terminaciones", label: "Terminaciones · M-13",
                icon: FileCheck2,
                roles: [
                    ROLES.JURIDICO, ROLES.ADMINISTRADOR_FIDUCIARIO, ROLES.TESORERIA,
                    ROLES.FINANZAS, ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR,
                    ROLES.CONSEJO,
                ],
            },
            {
                to: "/control/poderes", label: "Poderes · M-14",
                icon: KeyRound,
                roles: [
                    ROLES.JURIDICO, ROLES.ADMINISTRADOR_FIDUCIARIO,
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.CONSEJO,
                ],
            },
            {
                to: "/control/requerimientos", label: "Requerimientos autoridad · M-15",
                icon: Gavel,
                roles: [
                    ROLES.JURIDICO, ROLES.CUMPLIMIENTO,
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.CONSEJO,
                ],
            },
            {
                to: "/control/contingencia", label: "Instrucciones contingencia",
                icon: Zap,
                roles: [
                    ROLES.OPERACIONES, ROLES.TESORERIA, ROLES.FINANZAS,
                    ROLES.ADMINISTRADOR_FIDUCIARIO, ROLES.DIRECCION,
                    ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.CONSEJO,
                ],
            },
        ],
    },
    {
        label: "Regulatorios · Fase 18",
        items: [
            {
                to: "/direccion/dashboard", label: "Dashboard DG",
                icon: LineChart,
                roles: [ROLES.DIRECCION, ROLES.CONSEJO, ROLES.ADMIN_TI],
            },
            {
                to: "/control/estados-cuenta", label: "Estados de cuenta · M-10",
                icon: Receipt,
                roles: [
                    ROLES.OPERACIONES, ROLES.FINANZAS, ROLES.ADMINISTRADOR_FIDUCIARIO,
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.CONSEJO,
                ],
            },
            {
                to: "/control/nom151", label: "NOM-151 Sellos TSA",
                icon: ShieldAlert,
                roles: [ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.DIRECCION, ROLES.CONSEJO],
            },
            {
                to: "/control/archivo-concentracion", label: "Archivo de concentración",
                icon: FolderClosed,
                roles: [ROLES.JURIDICO, ROLES.DIRECCION, ROLES.ADMIN_TI,
                         ROLES.AUDITOR, ROLES.CONSEJO],
            },
            {
                to: "/fiscal/retenciones-lisr", label: "Retenciones LISR",
                icon: Calculator,
                roles: [
                    ROLES.FINANZAS, ROLES.ADMINISTRADOR_FIDUCIARIO,
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.CONSEJO,
                ],
            },
            {
                to: "/control/bcp", label: "BCP · Pruebas de continuidad",
                icon: Zap,
                roles: [ROLES.ADMIN_TI, ROLES.DIRECCION, ROLES.AUDITOR, ROLES.CONSEJO],
            },
            {
                to: "/control/inversiones", label: "Inversiones · M-08",
                icon: Coins,
                roles: [
                    ROLES.TESORERIA, ROLES.FINANZAS, ROLES.ADMINISTRADOR_FIDUCIARIO,
                    ROLES.DIRECCION, ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.CONSEJO,
                ],
            },
        ],
    },
    {
        label: "Sistema",
        items: [
            {
                to: "/listas-negras",
                label: "Listas negras (MOCK)",
                icon: ShieldAlert,
                roles: [ROLES.CUMPLIMIENTO, ROLES.ADMIN_TI, ROLES.AUDITOR, ROLES.DIRECCION],
            },
            {
                to: "/bitacora",
                label: "Bitácora",
                icon: Shield,
                roles: [ROLES.AUDITOR, ROLES.DIRECCION, ROLES.ADMIN_TI],
            },
            {
                to: "/usuarios",
                label: "Usuarios y roles",
                icon: UserCog,
                roles: [ROLES.ADMIN_TI],
            },
            {
                to: "/leads",
                label: "Leads (landing)",
                icon: Mail,
                roles: [ROLES.DIRECCION, ROLES.ADMIN_TI],
            },
        ],
    },
];

// Vista específica para role parte_externa — solo Portal Externo
const PARTE_EXTERNA_SECTIONS = [
    {
        label: "Portal Lender",
        items: [
            { to: "/v1/portal-externo", label: "Mi portal", icon: ExternalLink, end: true },
        ],
    },
];

const OPERATOR_SECTION = {
    label: "Operador · Trafalgar",
    items: [
        { to: "/admin/dashboard-operacion", label: "Panel operativo", icon: Zap },
        { to: "/admin/tenants", label: "Tenants", icon: Layers },
    ],
};

export default function Sidebar() {
    const { hasRole, user } = useAuth();
    const { isSuperAdmin, tenant, isImpersonating } = useTenant();

    // Si el user SOLO tiene role parte_externa (y no es admin/auditor/dirección), reducir sidebar
    const onlyParteExterna = user?.roles?.length === 1 && user.roles[0] === ROLES.PARTE_EXTERNA;

    let sections;
    if (onlyParteExterna) {
        sections = PARTE_EXTERNA_SECTIONS;
    } else {
        sections = isSuperAdmin ? [OPERATOR_SECTION, ...SECTIONS] : SECTIONS;
    }

    return (
        <aside
            className="hidden lg:flex lg:flex-col w-[260px] shrink-0 border-r border-border bg-card"
            data-testid="app-sidebar"
        >
            <div className="h-16 px-5 flex items-center gap-3 border-b border-border">
                <img
                    src="/leon_emblema.png"
                    alt="Trafalgar"
                    className="h-9 w-9 object-contain"
                />
                <div className="leading-tight">
                    <div className="font-display text-lg text-foreground tracking-tight">
                        Trafalgar
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.2em] text-[color:var(--brand-dark-gold)] font-semibold">
                        Fiduciario
                    </div>
                </div>
            </div>
            {isImpersonating && (
                <div className="px-4 py-2 bg-[color:var(--brand-coral)]/10 border-b border-[color:var(--brand-coral)]/40 text-[10px] leading-tight">
                    <div className="flex items-center gap-1 uppercase tracking-widest font-semibold text-[color:var(--brand-coral)]">
                        <Zap className="h-3 w-3" /> Impersonando
                    </div>
                    <div className="mt-0.5 truncate text-muted-foreground">
                        {tenant?.nombre_comercial || tenant?.slug}
                    </div>
                </div>
            )}
            <nav className="flex-1 overflow-y-auto py-3 px-2">
                {sections.map((s) => (
                    <div key={s.label} className="mb-4">
                        <div className="nav-section">{s.label}</div>
                        {s.items
                            .filter((it) => !it.roles || hasRole(it.roles))
                            .map((it) => (
                                <NavLink
                                    key={it.to}
                                    to={it.to}
                                    end={it.end}
                                    className={({ isActive }) =>
                                        `nav-item ${isActive ? "active" : ""}`
                                    }
                                    data-testid={`nav-${it.to.replace(/\//g, "-").replace(/^-/, "")}`}
                                >
                                    <it.icon className="h-4 w-4 shrink-0" />
                                    <span className="flex-1 truncate">{it.label}</span>
                                    <ChevronRight className="h-3 w-3 opacity-40" />
                                </NavLink>
                            ))}
                    </div>
                ))}
            </nav>
            <div className="px-4 py-3 border-t border-border text-[11px] text-muted-foreground">
                <div className="flex items-center justify-between">
                    <span>Trafalgar · v0.14</span>
                    <span className="badge-gold">Fase 14</span>
                </div>
            </div>
        </aside>
    );
}
